import IconRenderer from "@/libs/contentful/helper/IconRenderer";
import L from "leaflet";
import {Marker} from "react-leaflet";
import {renderToStaticMarkup} from "react-dom/server";
import {useTranslations} from "next-intl";

interface Props {
    index: number,
    setDialogIndex: (index: number) => void,
    toggleDialog: (id: string) => void,
    latitude: number,
    longitude: number,
    icon: string
}

export default function MapMarker({toggleDialog, latitude, longitude, icon, index, setDialogIndex}: Props) {
    const t = useTranslations('LeafletMap');


    let renderIcon = "icon-location-pin"

    if (icon) {
        switch (icon) {
            case 'Apparel':
                renderIcon = 'icon-hanger'
                break;
            case 'Textile':
                renderIcon = 'icon-home-textile'
                break;
            case 'Dress':
                renderIcon = 'icon-dress'
                break;
            case 'Shoe':
                renderIcon = 'icon-shoe'
                break;
        }
    }

    const htmlIcon = '<button type="button" aria-label="' + t("button") + '" class="bg-black rounded-tl-[50%] rounded-tr-[50%] rounded-br-[50%] rounded-bl-0 -rotate-45 border-white  border-2 w-full h-full text-white flex justify-center items-center"> ' +
        renderToStaticMarkup(<IconRenderer icon={renderIcon} className="rotate-45" FillColor="white"/>) +
        '</button>'


    const ICON = L.divIcon({
        iconSize: [35, 35],
        iconAnchor: [0, 0],
        className: "",
        html: htmlIcon,
    })

    return (
        <Marker position={[latitude, longitude]} icon={ICON}
                eventHandlers={{
                    click: () => {
                        toggleDialog('mapDialog')
                        setDialogIndex(index)
                    },
                    keypress: (e) => {
                        e.originalEvent.key === 'Enter' ? toggleDialog('mapDialog') : null
                    }
                }}
        />
    )
}